import { render, staticRenderFns } from "./Lazy-load.vue?vue&type=template&id=a4c79564&scoped=true&"
import script from "./Lazy-load.vue?vue&type=script&lang=js&"
export * from "./Lazy-load.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c79564",
  null
  
)

export default component.exports